import { Injectable } from '@angular/core';
import { ApiDirectory } from '@core/api/api-directory';
import { RequestResponse } from '@core/services/request/model/request.model';
import { RequestService } from '@core/services/request/request.service';
import { map, Observable } from 'rxjs';
import {
  ComparativeConsumptionApi,
  ConsumptionFilterApi,
  DailyComparativeConsumptionApi,
  MonthlyComparativeConsumptionApi,
  YearlyComparativeConsumptionApi,
} from '@core/api/model/consumption/consumption-api.model';
import { HttpParamsService } from '@core/services/http-params/http-params.service';
import { LoadingIds } from '@shared/constants/loading';

@Injectable({
  providedIn: 'root',
})
export class ApiComparativeService {
  constructor(
    private _requestService: RequestService,
    private _httpParamsService: HttpParamsService
  ) {}

  public fetchDaily(filter: ConsumptionFilterApi): Observable<RequestResponse<ComparativeConsumptionApi<DailyComparativeConsumptionApi>>> {
    const dia = filter.FechaDesde.split('T')[0];
    return this._requestService
      .get<RequestResponse<ComparativeConsumptionApi<DailyComparativeConsumptionApi>>>(ApiDirectory.Consumo.ComparativaDiaria({}), {
        params: this._httpParamsService.toParams(filter),
        hideErrorAlert: true,
        loading: LoadingIds.FETCH_COMPARATIVE_CONSUMPTION,
      })
      .pipe(
        map((response) => {
          return {
            ...response,
            data: response.data.map((consumptionByCups) => {
              return {
                ...consumptionByCups,
                datosConsumos: consumptionByCups.datosConsumos.map((datoConsumo) => {
                  return {
                    ...datoConsumo,
                    dia,
                  };
                }),
              };
            }),
          };
        })
      );
  }

  public fetchMonthly(
    filter: ConsumptionFilterApi
  ): Observable<RequestResponse<ComparativeConsumptionApi<MonthlyComparativeConsumptionApi>>> {
    return this._requestService.get(ApiDirectory.Consumo.ComparativaMensual({}), {
      params: this._httpParamsService.toParams(filter),
      hideErrorAlert: true,
      loading: LoadingIds.FETCH_COMPARATIVE_CONSUMPTION,
    });
  }

  public fetchYearly(
    filter: ConsumptionFilterApi
  ): Observable<RequestResponse<ComparativeConsumptionApi<YearlyComparativeConsumptionApi>>> {
    return this._requestService.get(ApiDirectory.Consumo.ComparativaAnual({}), {
      params: this._httpParamsService.toParams(filter),
      hideErrorAlert: true,
      loading: LoadingIds.FETCH_COMPARATIVE_CONSUMPTION,
    });
  }

  public downloadExcelDaily(filter: ConsumptionFilterApi) {
    return this._requestService.downloadWithProgress(ApiDirectory.Consumo.ComparativaExcelDiaria({}), {
      params: this._httpParamsService.toParams(filter),
    });
  }

  public downloadExcelMonthly(filter: ConsumptionFilterApi) {
    return this._requestService.downloadWithProgress(ApiDirectory.Consumo.ComparativaExcelMensual({}), {
      params: this._httpParamsService.toParams(filter),
    });
  }

  public downloadExcelYearly(filter: ConsumptionFilterApi) {
    return this._requestService.downloadWithProgress(ApiDirectory.Consumo.ComparativaExcelAnual({}), {
      params: this._httpParamsService.toParams(filter),
    });
  }
}
